import ChainLogo from '@components/ChainLogo'
import TokenAvatar from '@components/TokenAvatar'
import { Chip, Divider, ListRow } from '@ui'
import React, { FC, ReactNode } from 'react'

export const Tag: FC<{ children: ReactNode }> = ({ children }) => (
  <Chip tone="neutral">{children}</Chip>
)

/** Key/value row for a `ListGroup`: label on the left, value on the right. */
export const InfoRow: FC<{ label: string; value: ReactNode }> = ({ label, value }) => (
  <ListRow
    dense
    secondary={label}
    trailing={<span className="tabular font-medium text-fg">{value}</span>}
  />
)

/**
 * Hairline between rows. Not needed inside a `ListGroup`, which draws its own hairlines.
 */
export const RowDivider: FC = () => <Divider />

/** 40px token avatar with the chain logo as a badge in the bottom-right corner. */
export const TokenWithChain: FC<{ logo?: string; fallbackName?: string; chainId: number }> = ({
  logo,
  fallbackName,
  chainId,
}) => (
  <span className="relative inline-flex">
    <TokenAvatar size={40} fallbackName={fallbackName} logo={logo} />
    <span className="absolute -right-1 -bottom-1 flex rounded-full bg-surface p-[3px]">
      <ChainLogo chain={String(chainId)} size={14} />
    </span>
  </span>
)
